import type { PageTemplateProps } from "./pageTemplateTypes";

/**
 * Slot-driven React template for the bulk marketing/content pages whose backend
 * {@code metadata.templateUid} is {@code "ContentStreamPageTemplate"} (legacy
 * {@code layout/contentStreamPage.jsp}). This is the largest catch-all template
 * (~1309 pages, e.g. {@code /Configurator/{CAHB,CAT,CAR,LW}}).
 *
 * Structure-copy parity of {@code contentStreamPage.jsp}: the single
 * {@code ContentStreamSlot} is rendered inside an {@code <article id="contentStream"
 * class="scha__cms">} wrapper, with the slot itself wrapped in a
 * {@code .ContentStreamSlot} element. Both wrappers are required for the CSS
 * layout in {@code CMS.less} (the {@code .scha__cms#contentStream >
 * .ContentStreamSlot} selector applies the column flex with the 64px gap).
 *
 * Content-stream pages have no React island, so {@code body} is null.
 */
export function ContentStreamPageTemplate({ slots, body }: PageTemplateProps) {
  return (
    <article id="contentStream" className="scha__cms">
      <div className="ContentStreamSlot">{slots.renderSlot("ContentStreamSlot")}</div>
      {body}
    </article>
  );
}
